import { Injectable, OnDestroy } from '@angular/core';
import { CanvasService } from '../../components/canvas.service';
import { map, mapTo, tap, takeUntil } from 'rxjs/operators';
import { fromEvent, Subject, Observable, merge } from 'rxjs';
import { Vector2, Raycaster, Vector3, Object3D } from 'three';
import { SceneService } from '../../components/scene.service';
import { Boundingbox2Controller } from '../../share/boundingbox2';
export interface Ng3MosueWheelEvent {
  position: Vector2;
  delta: number;
  event: WheelEvent;
}
@Injectable()
export class MouseCanvasService implements OnDestroy {
  private ray = new Raycaster();
  constructor(
    private canvas: CanvasService,
    private sceneService: SceneService,
  ) {}
  private stop = new Subject<void>();
  readonly hover$ = this.createHover$();
  readonly position$ = this.fromEventCurrentPosition('mousemove');
  readonly down$ = this.fromEventCurrentPosition('mousedown');
  readonly downWithButton$ = fromEvent<MouseEvent>(
    this.canvas.domElement,
    'mousedown',
  ).pipe(
    map((e) => {
      return {
        position: this.sceneService.clientPosition2ScenePosition(
          new Vector2(e.clientX, e.clientY),
        ),
        original: e,
      };
    }),
  );

  readonly up$ = this.fromEventCurrentPosition('mouseup');

  readonly leave$ = this.fromEventCurrentPosition('mouseleave');

  readonly wheel$: Observable<Ng3MosueWheelEvent> = fromEvent<WheelEvent>(
    this.canvas.domElement,
    'mousewheel',
  ).pipe(
    map((e) => {
      e.preventDefault();
      return {
        position: this.sceneService.clientPosition2ScenePosition(
          new Vector2(e.clientX, e.clientY),
        ),
        delta: e.deltaY,
        event: e,
      };
    }, takeUntil(this.stop)),
  );

  ngOnDestroy() {
    this.stop.next();
    this.stop.complete();
  }
  private fromEventCurrentPosition(name: string) {
    return fromEvent<MouseEvent>(this.canvas.domElement, name).pipe(
      map((e: MouseEvent) => {
        return new Vector2(e.clientX, e.clientY);
      }),
      map((p) => this.sceneService.clientPosition2ScenePosition(p)),
      takeUntil(this.stop),
    );
  }

  private createHover$(): Observable<boolean> {
    return merge(
      fromEvent(this.canvas.domElement, 'mouseenter').pipe(mapTo(true)),
      fromEvent(this.canvas.domElement, 'mouseleave').pipe(mapTo(false)),
    ).pipe(takeUntil(this.stop));
  }
  intersectObject(origin: Vector3, direction: Vector3, object?: Object3D) {
    this.ray.set(origin, direction);
    return this.ray.intersectObjects(
      object !== undefined ? [object] : this.sceneService.scene.children,
    );
  }
}
